module.exports = __webpack_public_path__ + "img/search-input.d759cb51.svg";